module.exports = __webpack_public_path__ + "img/cloud-done-outline.bf31d327.svg";